import { GOALS, formatMoney } from "./constants";
import type { ProgressAnswerProps } from "./types";
import {
  AnswerHeading,
  AnswerValue,
  Explanation,
  GoalDetail,
  GoalProgress,
  GoalSelectors,
  Selector,
  SmallNote,
} from "./styles";

export function ProgressAnswer({
  goal,
  selectedGoal,
  onGoalChange,
}: ProgressAnswerProps) {
  const percent = Math.round((goal.saved / goal.target) * 100);
  const remaining = formatMoney(goal.target - goal.saved);
  const goalButtons = GOALS.map((item, index) => {
    const isSelected = selectedGoal === index;
    return (
      <Selector
        type="button"
        key={item.name}
        aria-pressed={isSelected}
        onClick={() => onGoalChange(index)}
      >
        {item.name}
      </Selector>
    );
  });
  return (
    <>
      <AnswerHeading id="progress-answer-title">
        Something worth saving for.
      </AnswerHeading>
      <GoalSelectors role="group" aria-label="Sample savings goal">
        {goalButtons}
      </GoalSelectors>
      <GoalDetail>
        <h3>{goal.name}</h3>
        <p>{goal.note}</p>
      </GoalDetail>
      <AnswerValue>
        {formatMoney(goal.saved)} <span>of {formatMoney(goal.target)}</span>
      </AnswerValue>
      <GoalProgress
        value={goal.saved}
        max={goal.target}
        aria-label={`${goal.name}: ${percent}% saved`}
      />
      <Explanation className="goal-remainder">
        <strong>{percent}% of your goal</strong>
        <span>{remaining} to go</span>
      </Explanation>
      <SmallNote>
        Saved across both goals: <strong>€14,600</strong>
        <br />
        Progress reflects recorded balances.
      </SmallNote>
    </>
  );
}
